export type CsvCell = string | number | null | undefined;

/** A cell as CSV text: quoted when it holds a comma, a quote or a line break (a quote inside is doubled). */
function csvCell(value: CsvCell): string {
  const text = value === null || value === undefined ? "" : String(value);
  return /["\r\n,]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/**
 * Downloads a table as a CSV file: the header row, then one line per row. UTF-8 with a byte-order mark so Excel reads the text as it is
 * (a dash for a blank figure, a percent sign) instead of guessing a code page.
 */
export function downloadCsv(filename: string, headers: readonly string[], rows: CsvCell[][]): void {
  const lines = [headers, ...rows].map((line) => line.map(csvCell).join(","));
  const blob = new Blob(["﻿" + lines.join("\r\n") + "\r\n"], { type: "text/csv;charset=utf-8" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
